import { gql, useMutation, useQuery } from '@apollo/client'

import {
  SendVerificationEmail,
  SendVerificationEmailMutation,
  SendVerificationEmailMutationVariables,
  ValidateAccountQuery,
  ValidateAccountQueryVariables,
} from '@/clients/utoniq-core/schema'
import { useCurrentUser, useMessage, useRouter, useTranslation } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { setInputSignUpArtist } from '@/core/native/storage'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { router, routerPages } = useRouter<{ code?: string }>()
  const { t } = useTranslation('firebase')
  const { user } = useCurrentUser()
  const { showError } = useMessage()

  const { refetch } = useQuery<
    ValidateAccountQuery,
    ValidateAccountQueryVariables
  >(VALIDATE_ACCOUNT, { skip: true })

  const [sendVerificationEmail] = useMutation<
    SendVerificationEmailMutation,
    SendVerificationEmailMutationVariables
  >(SendVerificationEmail, {
    onCompleted() {
      router.push(routerPages.MailAuthArtist)
    },
  })

  return {
    state: {
      user,
      code: router.query.code,
    },
    actions: {
      async onSignUp({
        displayName,
        accountId,
        email,
        password,
        invitationCode,
      }) {
        const { data } = await refetch({ input: { email, accountId } })

        /**
         * @note
         * validateAccountクエリで既存のメールアドレス・アカウントIDがないか確認し、
         * すでに存在している場合はエラーメッセージを表示する
         */
        if (!data.validateAccount.email) {
          showError(new Error(t('auth.errors.auth/email-already-in-use')))
          return
        }
        if (!data.validateAccount.accountId) {
          showError(new Error(t('auth.errors.auth/uid-already-exists')))
          return
        }

        await sendVerificationEmail({ variables: { email } })
        await setInputSignUpArtist({
          displayName,
          accountId,
          email,
          password,
          invitationCode,
        })
      },
      async onSignUpSwitch() {},
      async onSignUpWithApple() {},
      async onSignUpWithGoogle() {},
    },
  }
})

const VALIDATE_ACCOUNT = gql`
  query ValidateAccount($input: ValidateAccountInput) {
    validateAccount(inputs: $input) {
      accountId
      email
    }
  }
`
